export const DIVIDER_WIDTH = 2;
export const SLIDER_STARTING_POSITION = 0.5;
